import React from "react";
import { Row, Col } from "react-bootstrap";

export interface ButtonBarProps {
    offset: number
    className?: string
    children?: React.ReactNode
}

const ButtonBar: React.FC<ButtonBarProps> = ({ offset, className, children }) => {
    let clsName = 'buttonbar'
    if (className)
        clsName+= ' ' + className

    return (
        <Row className={clsName} >
            <Col md={{ offset: offset, span: 12 - offset }}>
                <>
                    {children}
                </>
            </Col>
        </Row>
    );
}
export default ButtonBar;